import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, withModifiers as _withModifiers, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "messages scrollable",
  ref: "messages"
}
const _hoisted_2 = {
  key: 0,
  class: "chat-errors"
}
const _hoisted_3 = { class: "input-actions" }
const _hoisted_4 = { class: "admin-modal" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "admin-modal" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = { class: "admin-modal" }
const _hoisted_9 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PinnedMessages = _resolveComponent("PinnedMessages")!
  const _component_AdminMessage = _resolveComponent("AdminMessage")!
  const _component_NotificationBanner = _resolveComponent("NotificationBanner")!
  const _component_MentionInput = _resolveComponent("MentionInput")!
  const _component_Arrow = _resolveComponent("Arrow")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SmileIcon = _resolveComponent("SmileIcon")!
  const _component_EmojiPicker = _resolveComponent("EmojiPicker")!
  const _component_SendMessage = _resolveComponent("SendMessage")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_BlockUserModal = _resolveComponent("BlockUserModal")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["messages-container", { 'has-giveaway-banner': _ctx.hasGiveawaysBanner }])
  }, [
    _createVNode(_component_PinnedMessages, {
      onDelete: _ctx.openDeleteModal,
      onMute: _ctx.openMuteModal,
      onBlock: _ctx.openBlockModal,
      onUnpin: _ctx.openUnpinModal,
      editable: true
    }, null, 8, ["onDelete", "onMute", "onBlock", "onUnpin"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
        return (_openBlock(), _createBlock(_component_AdminMessage, {
          key: message.id,
          user: message.user,
          message: message,
          isLastMessageFromSameUser: _ctx.isLastMessageFromSameUser(message, index),
          isPrevMessageUserSame: _ctx.isPrevMessageUserSame(message, index),
          onDelete: ($event: any) => (_ctx.openDeleteModal(message)),
          onMute: ($event: any) => (_ctx.openMuteModal(message.user)),
          onBlock: ($event: any) => (_ctx.openBlockModal(message.user))
        }, null, 8, ["user", "message", "isLastMessageFromSameUser", "isPrevMessageUserSame", "onDelete", "onMute", "onBlock"]))
      }), 128))
    ], 512),
    (_ctx.chatErrors.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatErrors, (chatError) => {
            return (_openBlock(), _createBlock(_component_NotificationBanner, {
              key: chatError.message
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(chatError.message), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      class: "message-input",
      ref: "formRef",
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.sendMessage && _ctx.sendMessage(...args)), ["prevent"]))
    }, [
      _createVNode(_component_MentionInput, {
        ref: "mentionInput",
        disabled: !_ctx.user.id,
        modelValue: _ctx.text,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.text) = $event)),
        asyncSearch: _ctx.searchUsers,
        onSubmit: _cache[1] || (_cache[1] = () => _ctx.$refs.formRef.requestSubmit())
      }, null, 8, ["disabled", "modelValue", "asyncSearch"]),
      _withDirectives(_createVNode(_component_Button, {
        onClick: _cache[2] || (_cache[2] = () => _ctx.scrollToBottom(true)),
        class: "show-last",
        type: "primary",
        style: {"width":"20px","height":"20px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Arrow)
        ]),
        _: 1
      }, 512), [
        [_vShow, !_ctx.isScrolled]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_SmileIcon, {
          ref: "emojiToggle",
          style: {"cursor":"pointer"},
          "disable-skin-tone": true,
          onClick: _ctx.toggleEmojiPicker
        }, null, 8, ["onClick"]),
        (_ctx.emojiToggleEl)
          ? _withDirectives((_openBlock(), _createBlock(_component_EmojiPicker, {
              key: 0,
              style: {"position":"absolute","bottom":"40px","left":"0"},
              native: true,
              onSelect: _ctx.onSelectEmoji,
              theme: "dark"
            }, null, 8, ["onSelect"])), [
              [_vShow, _ctx.showEmojiPicker],
              [_directive_click_outside, {
            handler: _ctx.closeEmojiPicker,
            exclude: _ctx.emojiToggleEl,
          }]
            ])
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          action: "submit",
          type: "empty",
          style: {"width":"20px","height":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SendMessage)
          ]),
          _: 1
        })
      ])
    ], 544),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onClose: _ctx.closeActionModal,
          img: "Modal-background.png",
          name: "Delete message"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _cache[7] || (_cache[7] = _createElementVNode("p", null, "Delete this message?", -1)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  type: "primary__white",
                  size: "small",
                  onClick: _ctx.closeActionModal
                }, {
                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.confirmDeleteMessage
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Delete ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showMuteModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 2,
          onClose: _ctx.closeActionModal,
          img: "Modal-background.png",
          name: "Mute user"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("p", null, "Mute " + _toDisplayString(_ctx.selectedUser?.username) + " for:", 1),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.muteDuration) = $event)),
                  type: "number",
                  min: "60",
                  step: "60",
                  placeholder: "Duration in seconds"
                }, null, 512), [
                  [_vModelText, _ctx.muteDuration]
                ]),
                _cache[8] || (_cache[8] = _createTextVNode(" seconds ", -1))
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Button, {
                  type: "primary__white",
                  size: "small",
                  onClick: _ctx.closeActionModal
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.confirmMuteUser
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode(" Mute ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showBlockModal && _ctx.selectedUser)
      ? (_openBlock(), _createBlock(_component_BlockUserModal, {
          key: 3,
          user: _ctx.selectedUser,
          onClose: _ctx.closeActionModal
        }, null, 8, ["user", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showUnpinModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 4,
          onClose: _ctx.closeActionModal,
          img: "Modal-background.png",
          name: "Unpin message"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _cache[13] || (_cache[13] = _createElementVNode("p", null, "Are you sure you want to unpin this message?", -1)),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  type: "primary__white",
                  size: "small",
                  onClick: _ctx.closeActionModal
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  type: "primary",
                  size: "small",
                  onClick: _ctx.confirmUnpinMessage
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode(" Unpin ", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 2))
}